import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class ClientPolicyHistoryModel extends BaseModel {
  static urlPath = "client-policy-history";

  @attr("json") policyLimitSelection;
  @attr("json") uninsuredMotoristSelection;
}
